import React, { useState } from "react";
import HtmlIcon from "./HtmlIcon";
import SettingsIcon from "./SettingsIcon";
import Divider from "@mui/material/Divider";
import RadioButtonsGroup from "./RadioButtonsGroup";
import CustomizedInput from "../../CreateForm/InputBase";
import CustomizedColorInput from "../../CreateForm/ColorBase";
import CustomizedSingleSelectDropdown from "../../CreateForm/DropdownBase";
import FileUploadDialog from "../../CreateForm/DialogBase/FileUploadDialog";

import { useMediaQuery } from "@mui/material";
import { fontFamilies } from "../../../Utils/common";
import { globalColors } from "../../../Utils/colors";
import { IDataFromModal } from "../../../pages/Workspace/interface";

import {
  ChooseYourFileButton,
  EditButton,
  SelectableButton,
} from "../../Custom/Buttons";

import {
  BodyContainer,
  HeaderContainer,
  LandingPageExtraSpacingContainer,
  LandingPageHtmlButtonWrapper,
  LandingPageSmallSpacingContainer,
  LandingPageSpacingContainer,
  LandingPageTypeButtonsContainer,
  LandingPageTypeContainer,
  RootContainer,
  TextContainer,
} from "./styled";

import {
  ColorDetailsContainer,
  ColorEditButtonContainer,
  ColorPropertiesContainer,
  ColorSectionContainer,
  ColorTextContainer,
  ColorTitleSectionContainer,
  FontSectionContainer,
  FontTitleSectionContainer,
  TextAlignSectionContainer,
} from "../../CustomCss/styled";
import CustomizedSwitch from "../../CreateForm/SwitchBase";

interface LandingPageSettingsProps {
  editUUID: string;
  dataFromModal: IDataFromModal;
  setDataFromModal: (dataFromModal: IDataFromModal) => void;
}

interface BackgroundChangeHandlerProps {
  dataFromModal: IDataFromModal;
  setDataFromModal: (dataFromModal: IDataFromModal) => void;
  uploadValue: string;
  setUploadValue: (uploadValue: string) => void;
  openPopup: () => void;
}

interface ButtonStylesHandlerProps {
  dataFromModal: IDataFromModal;
  setDataFromModal: (dataFromModal: IDataFromModal) => void;
  colourPopup: number;
  setColourPopup: (colourPopup: number) => void;
  closeColourPopup: () => void;
}

const RadioButtonOptions = [
  { label: "Url", value: "url" },
  { label: "Upload an image", value: "upload" },
];

const BackgroundChangeHandler = ({
  dataFromModal,
  uploadValue,
  setDataFromModal,
  setUploadValue,
  openPopup,
}: BackgroundChangeHandlerProps) => {

  return (
    <React.Fragment>
      <TextContainer>Background</TextContainer>
      <LandingPageSmallSpacingContainer>
        <RadioButtonsGroup
          dataProvider={RadioButtonOptions}
          value={uploadValue}
          setValue={setUploadValue}
        />
      </LandingPageSmallSpacingContainer>
      <LandingPageSmallSpacingContainer>
        <CustomizedInput
          placeholder="Type URL"
          value={dataFromModal?.landingPageBackground}
          onChange={(
            event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
          ) => {
            setDataFromModal({
              ...dataFromModal,
              landingPageBackground: event.target.value,
            });
          }}
        />
      </LandingPageSmallSpacingContainer>
      {uploadValue === "upload" && (
        <LandingPageSpacingContainer>
          <ChooseYourFileButton onClick={openPopup} />
        </LandingPageSpacingContainer>
      )}
    </React.Fragment>
  );
};

const ButtonStylesHandler = ({
  dataFromModal,
  setDataFromModal,
  colourPopup,
  setColourPopup,
  closeColourPopup,
}: ButtonStylesHandlerProps) => {
  const isLessThan1550 = useMediaQuery("(max-width:1551px)");

  return (
    <LandingPageExtraSpacingContainer>
      <TextContainer>Button</TextContainer>
      <TextContainer>Button Text</TextContainer>
      <CustomizedInput
        placeholder="Type Here"
        value={dataFromModal?.landBtnText}
        onChange={(
          event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
        ) => {
          setDataFromModal({
            ...dataFromModal,
            landBtnText: event.target.value,
          });
        }}
      />
      <FontSectionContainer isLargeScreen={!isLessThan1550}>
        <FontTitleSectionContainer isLargeScreen={!isLessThan1550}>
          Font
        </FontTitleSectionContainer>
        <CustomizedSingleSelectDropdown
          dataProvider={fontFamilies}
          value={dataFromModal?.landBtnFont}
          setValue={(value: string) => {
            setDataFromModal({
              ...dataFromModal,
              landBtnFont: value,
            });
          }}
        />
      </FontSectionContainer>
      <ColorSectionContainer isLargeScreen={!isLessThan1550}>
        <ColorTitleSectionContainer isLargeScreen={!isLessThan1550}>
          Text Colour
        </ColorTitleSectionContainer>
        <ColorPropertiesContainer>
          <ColorDetailsContainer>
            <CustomizedColorInput
              open={colourPopup === 1}
              closeHandler={closeColourPopup}
              color={dataFromModal?.landTextColor}
              setColor={(colour: string) => {
                setDataFromModal({
                  ...dataFromModal,
                  landTextColor: colour,
                });
              }}
            />
            <ColorTextContainer>
              {dataFromModal?.landTextColor}
            </ColorTextContainer>
          </ColorDetailsContainer>
          <ColorEditButtonContainer>
            <EditButton
              onClick={() => {
                setColourPopup(1);
              }}
            />
          </ColorEditButtonContainer>
        </ColorPropertiesContainer>
      </ColorSectionContainer>
      <ColorSectionContainer isLargeScreen={!isLessThan1550}>
        <ColorTitleSectionContainer isLargeScreen={!isLessThan1550}>
          Button Colour
        </ColorTitleSectionContainer>
        <ColorPropertiesContainer>
          <ColorDetailsContainer>
            <CustomizedColorInput
              open={colourPopup === 2}
              closeHandler={closeColourPopup}
              color={dataFromModal?.landBtnColor}
              setColor={(colour: string) => {
                setDataFromModal({
                  ...dataFromModal,
                  landBtnColor: colour,
                });
              }}
            />
            <ColorTextContainer>
              {dataFromModal?.landBtnColor}
            </ColorTextContainer>
          </ColorDetailsContainer>
          <ColorEditButtonContainer>
            <EditButton
              onClick={() => {
                setColourPopup(2);
              }}
            />
          </ColorEditButtonContainer>
        </ColorPropertiesContainer>
      </ColorSectionContainer>
    </LandingPageExtraSpacingContainer>
  );
};

export default function LandingPageSettings({
  editUUID,
  dataFromModal,
  setDataFromModal,
}: LandingPageSettingsProps) {
  const isLessThan1550 = useMediaQuery("(max-width:1551px)");
  const [colourPopup, setColourPopup] = useState<number>(0);
  const [uploadValue, setUploadValue] = useState<string>("url");
  const [uploadPopup, setUploadPopup] = useState<boolean>(false);

  const openPopup = () => {
    setUploadPopup(true);
  };

  const closePopup = (url?: string) => {
    if (url) {
      setDataFromModal({
        ...dataFromModal,
        landingPageBackground: url,
      });
      setUploadPopup(false);
    } else {
      setUploadPopup(false);
    }
  };

  const closeColourPopup = () => {
    setColourPopup(0);
  };

  const htmlIconFillColor = React.useMemo(() => {
    return dataFromModal?.landContentType === "html"
      ? globalColors.white
      : globalColors.primary;
  }, [dataFromModal]);

  const onHtmlClicked = () => {
    setDataFromModal({
      ...dataFromModal,
      landContentType: "html",
      html: "",
      landCustomContentColour: "#ffffff",
      landCustomContentFont: "Poppins",
    });
  };

  const onCustomClicked = () => {
    setDataFromModal({
      ...dataFromModal,
      html: "",
      landContentType: "custom",
      landCustomContentColour: "#ffffff",
      landCustomContentFont: "Poppins",
      landingPageBackground:
        "https://waymore.io/wp-content/uploads/2022/12/image_2022_12_23T11_58_29_928Z.png",
    });
  };

  // setIsCenterAlign(centerAlign)
  const handleCenterAlign = (centerAlign: boolean) => {

    let htmlContent = dataFromModal.html || '';

    if (htmlContent.includes("<body")) {
      const bodyStartIndex = htmlContent.indexOf(">", htmlContent.indexOf("<body")) + 1;
      // const bodyStartIndex = htmlContent.indexOf("<body") + htmlContent.indexOf(">", htmlContent.indexOf("<body")) + 1;
      const bodyEndIndex = htmlContent.indexOf("</body>");

      // Split content around <body>
      const beforeBody = htmlContent.slice(0, bodyStartIndex);
      const afterBody = htmlContent.slice(bodyEndIndex);
      let bodyContent = htmlContent.slice(bodyStartIndex, bodyEndIndex);

      if (centerAlign) {
        // Check if an immediate <div> exists inside <body>
        const firstDivMatch = bodyContent.match(/^<div[^>]*>/);

        if (firstDivMatch) {
          const firstDivTag = firstDivMatch[0];

          // Modify or add text-align:center in the style attribute
          if (firstDivTag.includes("style=")) {
            if (!firstDivTag.includes("text-align:center")) {
              bodyContent = bodyContent.replace(
                firstDivTag,
                firstDivTag.replace('style="', 'style="text-align:center; ')
              );
            }
          } else {
            bodyContent = bodyContent.replace(
              firstDivTag,
              firstDivTag.replace("<div", '<div style="text-align:center;"')
            );
          }
        } else {
          // No immediate <div>, so wrap body content in <div style="text-align:center;">
          bodyContent = `<div style="text-align:center;">${bodyContent}</div>`;
        }
      } else {
        // Remove text-align:center from style if present
        bodyContent = bodyContent.replace(
          /(<div[^>]*style="[^"]*)text-align:center;\s?/,
          "$1"
        );
      }

      // Update the html with modified content
      setDataFromModal({
        ...dataFromModal,
        html: beforeBody + bodyContent + afterBody
      });
    } else {
      // No <body> tag: wrap entire content in <div style="text-align:center;">
      if (centerAlign) {
        htmlContent = `<div style="text-align:center;">${htmlContent}</div>`;
      } else {
        // Remove text-align:center if already wrapped
        htmlContent = htmlContent.replace(
          /^<div[^>]*style="[^"]*text-align:center[^"]*"[^>]*>([\s\S]*?)<\/div>$/,
          "$1"
        );
      }

      setDataFromModal({
        ...dataFromModal,
        html: htmlContent
      });
    }
  };


  const ensureTextAlignCenter = () => {
    let htmlContent = dataFromModal.html || '';

    // Check if <body> tag is present
    const bodyStartIndex = htmlContent.indexOf("<body");
    if (bodyStartIndex !== -1) {
      // <body> exists
      const bodyEndIndex = htmlContent.indexOf(">", bodyStartIndex) + 1;
      const afterBodyContent = htmlContent.slice(bodyEndIndex);

      // Check if there's a <div> with text-align:center style immediately inside <body>
      const firstDivMatch = afterBodyContent.match(/^<div[^>]*style="[^"]*text-align:center[^"]*"/);

      if (firstDivMatch) {
        // Text-align:center is already applied, so no changes needed
        return true;
      } else {
        return false;
      }
    } else {
      // No <body> tag; check if content starts with a <div> with text-align:center
      const firstDivMatch = htmlContent.match(/^<div[^>]*style="[^"]*text-align:center[^"]*"/);

      if (firstDivMatch) {
        // Text-align:center is already applied, so no changes needed
        return true;
      } else {
        return false;
      }
    }
  };


  return (
    <RootContainer>
      <HeaderContainer>Welcome page settings</HeaderContainer>
      <Divider />
      <BodyContainer>
        <LandingPageTypeContainer>
          <TextContainer>Please choose your welcome page type</TextContainer>
          <LandingPageTypeButtonsContainer>
            <LandingPageHtmlButtonWrapper>
              <SelectableButton
                iconRenderer={() => <HtmlIcon fill={htmlIconFillColor} />}
                isSelected={dataFromModal?.landContentType === "html"}
                onClick={onHtmlClicked}
                title="HTML"
              />
            </LandingPageHtmlButtonWrapper>
            <SelectableButton
              iconRenderer={() => <SettingsIcon />}
              isSelected={dataFromModal?.landContentType === "custom"}
              onClick={onCustomClicked}
              title="Welcome message"
            />
          </LandingPageTypeButtonsContainer>
        </LandingPageTypeContainer>
        {dataFromModal?.landContentType === "html" && (
          <React.Fragment>
            <LandingPageTypeContainer>
              <TextContainer>Enter the HTML of your welcome page</TextContainer>
              <LandingPageSpacingContainer>
                <CustomizedInput
                  placeholder="Type HTML"
                  multiline
                  minRows="4"
                  maxRows="8"
                  value={dataFromModal?.html}
                  onChange={(
                    event: React.ChangeEvent<
                      HTMLTextAreaElement | HTMLInputElement
                    >
                  ) => {
                    setDataFromModal({
                      ...dataFromModal,
                      html: event.target.value,
                    });
                  }}
                />
              </LandingPageSpacingContainer>
            </LandingPageTypeContainer>
            <LandingPageSpacingContainer />
            <HeaderContainer>Styles</HeaderContainer>
            <Divider />
            <LandingPageSpacingContainer />
            <TextAlignSectionContainer isLargeScreen={!isLessThan1550}>
              <FontTitleSectionContainer isLargeScreen={!isLessThan1550}>
                Align Text Center
              </FontTitleSectionContainer>
              <CustomizedSwitch
                checked={ensureTextAlignCenter()}
                changeHandler={(e) => handleCenterAlign(e.target.checked)}
              />
            </TextAlignSectionContainer>
            <BackgroundChangeHandler
              dataFromModal={dataFromModal}
              uploadValue={uploadValue}
              setDataFromModal={setDataFromModal}
              setUploadValue={setUploadValue}
              openPopup={openPopup}
            />
            <ButtonStylesHandler
              dataFromModal={dataFromModal}
              colourPopup={colourPopup}
              setDataFromModal={setDataFromModal}
              setColourPopup={setColourPopup}
              closeColourPopup={closeColourPopup}
            />
          </React.Fragment>
        )}
        {dataFromModal?.landContentType === "custom" && (
          <React.Fragment>
            <LandingPageTypeContainer>
              <TextContainer>Craft Your Welcome Message</TextContainer>
              <LandingPageSpacingContainer>
                <CustomizedInput
                  placeholder="Provide a welcoming message and any essential information for your audience. keep your introduction concise and focused. Please limit your introduction to 150 words."
                  multiline
                  minRows="4"
                  maxRows="8"
                  value={dataFromModal?.html}
                  onChange={(
                    event: React.ChangeEvent<
                      HTMLTextAreaElement | HTMLInputElement
                    >
                  ) => {
                    setDataFromModal({
                      ...dataFromModal,
                      html: event.target.value,
                    });
                  }}
                />
              </LandingPageSpacingContainer>
            </LandingPageTypeContainer>
            <LandingPageSpacingContainer />
            <HeaderContainer>Styles</HeaderContainer>
            <Divider />
            <LandingPageSpacingContainer />
            <BackgroundChangeHandler
              dataFromModal={dataFromModal}
              uploadValue={uploadValue}
              setDataFromModal={setDataFromModal}
              setUploadValue={setUploadValue}
              openPopup={openPopup}
            />
            <LandingPageExtraSpacingContainer>
              <TextContainer>Font</TextContainer>
              <FontSectionContainer isLargeScreen={!isLessThan1550}>
                <FontTitleSectionContainer isLargeScreen={!isLessThan1550}>
                  Font Family
                </FontTitleSectionContainer>
                <CustomizedSingleSelectDropdown
                  dataProvider={fontFamilies}
                  value={dataFromModal?.landCustomContentFont}
                  setValue={(value: string) => {
                    setDataFromModal({
                      ...dataFromModal,
                      landCustomContentFont: value,
                    });
                  }}
                />
              </FontSectionContainer>
              <ColorSectionContainer isLargeScreen={!isLessThan1550}>
                <ColorTitleSectionContainer isLargeScreen={!isLessThan1550}>
                  Colour
                </ColorTitleSectionContainer>
                <ColorPropertiesContainer>
                  <ColorDetailsContainer>
                    <CustomizedColorInput
                      open={colourPopup === 3}
                      closeHandler={closeColourPopup}
                      color={dataFromModal?.landCustomContentColour}
                      setColor={(colour: string) => {
                        setDataFromModal({
                          ...dataFromModal,
                          landCustomContentColour: colour,
                        });
                      }}
                    />
                    <ColorTextContainer>
                      {dataFromModal?.landCustomContentColour}
                    </ColorTextContainer>
                  </ColorDetailsContainer>
                  <ColorEditButtonContainer>
                    <EditButton
                      onClick={() => {
                        setColourPopup(3);
                      }}
                    />
                  </ColorEditButtonContainer>
                </ColorPropertiesContainer>
              </ColorSectionContainer>
            </LandingPageExtraSpacingContainer>
            <ButtonStylesHandler
              dataFromModal={dataFromModal}
              colourPopup={colourPopup}
              setDataFromModal={setDataFromModal}
              setColourPopup={setColourPopup}
              closeColourPopup={closeColourPopup}
            />
          </React.Fragment>
        )}
      </BodyContainer>
      <FileUploadDialog
        open={uploadPopup}
        submitHandler={closePopup}
        editUUID={editUUID}
      />
    </RootContainer>
  );
}
